import React from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import SVGIcon from '../../../../../../common/react/components/svg-icon';

export default class ButtonsSection extends React.Component {
	render() {
		
		let { localization } = this.props;

		return (
			<section className='buttons'>
				<h2>{localization.substitute('Buttons')}</h2>
				<div className='label-wrapper'>
					<label htmlFor='submit_button_label_input'>
						{localization.substitute('Submit Button Label')}
					</label>
				</div>
				<input
					ref='submitButtonLabelInput'
					id='submit_button_label_input'
					type='text'
					placeholder={localization.substitute(Defaults.SUBMIT_BUTTON_LABEL)}
					defaultValue={localization.substitute(this.props.submitButtonLabel)}
					onBlur={this.handleContentChange(FormSettings.SUBMIT_BUTTON_LABEL)}
				></input>
			</section>
		);
	}
	
	// Custom Methods ------------------------------------------------------------
	handleToggle = (propertyName) => {
		return (evt) => {
			this.props.updateCallback(propertyName, evt.target.checked);
		}
	}

	handleContentChange = (propertyName) => {
		let { localization } = this.props;
		return (evt) => {
			if ( this.refs.submitButtonLabelInput.value !== '' ) {
				this.props.updateCallback(propertyName, this.refs.submitButtonLabelInput.value);
			} else {
				this.props.updateCallback(propertyName, localization.substitute(Defaults.SUBMIT_BUTTON_LABEL));
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/buttons.js